export var TwitterChannelType;
(function (TwitterChannelType) {
    TwitterChannelType[TwitterChannelType["DIRECT_MESSAGE"] = 0] = "DIRECT_MESSAGE";
    TwitterChannelType[TwitterChannelType["MENTION_ON_ORIGINAL_TWEET"] = 10] = "MENTION_ON_ORIGINAL_TWEET";
    TwitterChannelType[TwitterChannelType["MENTION_ON_REPLY"] = 20] = "MENTION_ON_REPLY";
})(TwitterChannelType || (TwitterChannelType = {}));
//# sourceMappingURL=twitter-channel-type.enum.js.map